export default {
    ADD_NOTIFIED_THRYV_USER(state, { sub }) {
        state.notifiedThryvMigratedUsers.push(sub);
    },
};
